export enum DocsVerificationLivenessTagErrorEnum {
    MULTIPARTY = 'multiparty',
    FLAT = 'flat',
    TIME_EXPIRED = 'time_expired',
    TIME_OUTSIDE_EXPIRED = 'time_outside_expired',
    FIRST_SCREEN = 'first_screen',
}
